import React, {Component} from 'react';
import {Button, List, InputItem, WhiteSpace, Modal, Flex, Toast, WingBlank} from 'antd-mobile';
import {ROOT_PATH} from '../../../config';
import auth from '../../../utils/auth';
import send_init from '../../../utils/send_init'
import InputNumber from '../../../components/InputNumber';
import native from '../../../utils/native';

const ModalAlert = Modal.alert;
const ROLEDATA = [
  {
    label: '养殖场老板',
    value: '1',
    checked: false
  },
  {
    label: '养殖场场长',
    value: '2',
    checked: false
  },
  {
    label: '技术员',
    value: '37',
    checked: false
  },
  {
    label: '业务员',
    value: '36',
    checked: false
  }
];
export default class Staff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeStaff: [],// 当前已经添加的用户
      currentBtnType: 'add',
      newStaff: true, // 是否是新员工，也就是农场中没有。
      contact: false, // 引入，关联
      hasError: false,
      id: '',
      name: '',
      tel: '',
      role: [{
        label: '养殖场老板',
        value: '1',
        checked: true
      },
        {
          label: '养殖场场长',
          value: '2',
          checked: false
        },
        {
          label: '技术员',
          value: '37',
          checked: false
        },
        {
          label: '业务员',
          value: '36',
          checked: false
        }]
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  checkDefaultStaff = async () => {
    const farmOrg = auth.readCookie('FARMORG') + '-0-0';
    const orgCode = auth.readCookie('ORGCODE');
    const farm = auth.readCookie('farm');
    const phone = farm.tel;
    //员工。默认添加 猪场创建时候的 用户
    let res = await send_init({
      url: '/api/ifarm/v180/staff/staff',
      method: 'get',
      params: {
        tel_mobile: phone,
        code: farmOrg,
        parent_code: orgCode
      }
    });
    let newStaff = (res.data.data === null); // 是新员工;
    let id = newStaff?'':res.data.data.id;
    this.setDefaultStaff(id, newStaff)
  };
  async componentDidMount() {
    if (!auth.readCookie('staff')) {
      this.checkDefaultStaff()
    } else{
      this.setState({
        storeStaff: auth.readCookie('staff')
      })
    }
  }
  setDefaultStaff = (id, newStaff) => {
    // 默认添加 农场所填用户为老板，技术员，业务员
    const farm = auth.readCookie('farm');
    let defaultStaff = [{
      'name': farm.farmMan,
      'tel': farm.tel,
      'id': id,
      'role': [
        {'label': '养殖场老板', 'value': '1', 'checked': true},
        {'label': '养殖场场长','value': '2', 'checked': false},
        {'label': '技术员', 'value': '37', 'checked': true},
        {'label': '业务员', 'value': '36', 'checked': true}
      ],
      'contact': true,
      'newStaff': newStaff
    }];
    this.setState({
      storeStaff:defaultStaff
    });
    auth.setCookie('staff', defaultStaff)
  };
  validateInput = () => {
    const {name, tel, role, hasError} = this.state;
    let err = 0;
    // todo 校验
    if (!name) {
      Toast.info('请输入 猪场负责人', 2);
      err++;
    } else if (!tel) {
      Toast.info('请输入 手机号码', 2);
      err++;
    } else if (hasError) {
      Toast.info(this.state.errMsg + '!!', 2);
      err++;
    } else if (auth.readCookie('staff').filter(o => tel === o.tel).length !== 0) {
      Toast.info('手机号码重复', 2);
      this.setState({hasError: true,errMsg: '手机号码已存在'});
      err++;
    } else if (role.filter(o=>o.checked).length === 0) {
      Toast.info('请至少选择一种角色', 2);
      err++
    }
    return err === 0
  };
  validateTel = async () => {
    const {tel} = this.state;
    const farmOrg = auth.readCookie('FARMORG') + '-0-0';
    const orgCode = auth.readCookie('ORGCODE');
    const phone = tel.replace(/ /g, '');
    let res = await send_init({
      url: '/api/ifarm/v180/staff/staff',
      method: 'get',
      params: {
        tel_mobile: phone,
        code: farmOrg,
        parent_code: orgCode
      }
    });
    let newStaff = (res.data.data === null); // 是新员工;
    this.setState({
      newStaff, // 是新员工
      id: newStaff?'':res.data.data.id
    }, () => {
      const title = newStaff ? '新员工': '老员工';
      const message = newStaff ? '引入后该员工可以使用养殖管理协助您管理猪场': '该号码已经存在，关联后可以使用养殖管理协助您管理猪场';
      this.importStaff(
        this.state,
        {title, message}
      )
    })
  };
  doAdd = async () => {
    console.log('添加员工');
    this.setState({currentBtnType: 'add'});
    // 创建完成: lastOne  ,继续录入：continueAdd
    // do： 1校验当前手机号是否注册。[是：老员工，关联账号， 新员工：提示引入]
    const err = this.validateInput(); // 验证必填。
    if (err) { // 当没有错误，则继续执行。
      // 2 验证手机号开始
      this.validateTel()
    }
  };
  doSave = () => {
    this.setState({currentBtnType: 'save'});
    const {name,tel} = this.state;
    if (name && tel) {
      console.log('validata');
      const err = this.validateInput(); // 验证必填。
      if (err) { // 当没有错误，则继续执行。
        // 2 验证手机号开始
        this.validateTel()
      }
    } else {
      console.log('save data');
      this.saveData()
    }
  };
  initRender = () => {
    this.setState({
      hasError: false,
      storeStaff: auth.readCookie('staff'),
      name: '',
      id: '',
      tel: '',
      role: [
        {
          label: '养殖场老板',
          value: '1',
          checked: true
        },
        {
          label: '养殖场场长',
          value: '2',
          checked: false
        },
        {
          label: '技术员',
          value: '37',
          checked: false
        },
        {
          label: '业务员',
          value: '36',
          checked: false
        }
      ]
    })
  };
  importStaff = (state, msg) => {
    console.log(state,msg);
    //修改改员工的contact属性，（表示是否引入）
    ModalAlert(msg.title ,
      msg.message,
      [
        {
          text: '不需要',
          onPress: () => {
            this.setState({
              contact:false
            }, () => {
              this.addStaff( )
            })
          }
        },
        {
          text: '引入',
          onPress: () => {
            this.setState({
              contact:true
            }, () => {
              this.addStaff( )
            })
          }
        }
      ]
    )
  };
  addStaff = () => {
    // 把员工添加到内存
    const state = this.state;
    // 根据当前点击的是继续，还是完成调用不同的方法。
    this.setState(state => {
      state.storeStaff.push({
        name: state.name,
        tel: state.tel,
        id: state.id,
        role: state.role,
        contact: state.contact,
        newStaff: state.newStaff
      });
      return state;
    }, () => {
      this.setData(this.state.storeStaff);
      if (state.currentBtnType === 'add') {
        // 继续录入
        Toast.success(`${state.name},添加成功,请继续录入!`, 1.5);
        this.initRender()
      } else {
        // 创建完成。
        console.log('save data');
        this.saveData()
      }

    })

  };
  formatNum = (index) => {
    let str = '';
    if (index < 9) {
      str = '00' + (index + 1)
    } else if (index < 99) {
      str = '0' + (index + 1)
    } else {
      str = index + 1
    }
    return str
  };
  getSaveData = () => {
    const loc = auth.readCookie('loc');
    const farm = auth.readCookie('farm');
    if (!loc || !farm) {
      Toast.info('流程错误', 2);
      return;
    }
    const province = JSON.parse(farm.address[0] || '');
    const city = JSON.parse(farm.address[1] || '');
    const town = JSON.parse(farm.address[2] || '');
    let farrow = loc.loc2Names.map((o, index) => {
      return {
        grp: this.formatNum(index),
        index: index < 10 ? '0' + index : index,
        locationBar: o.num * 1,
        locationName: o.name + '001批'
      }
    });
    let mate = loc.loc1Names.map((o, index) => {
      return {
        grp: this.formatNum(index),
        index: index < 10 ? '0' + index : index,
        locationBar: o.num * 1,
        locationName: o.name + '001批'
      }
    });
    let gilt = loc.loc6Names.map((o, index) => {
      return {
        grp: this.formatNum(index),
        index: index < 10 ? '0' + index : index,
        locationBar: null,
        locationName: o.name + '001批'
      }
    });
    let finishing = [];
    for (var i = 0; i < loc.loc4Names.length; i++) {
      var locName4 = loc.loc4Names[i];
      for (var j = 0; j < locName4.batchNames.length; j++) {
        var batchName4 = locName4.batchNames[j];
        finishing.push({
          grp: this.formatNum(j),
          index: i < 10 ? '0' + (i + 1) : i + 1,
          locationBar: null,
          locationName: locName4.name + batchName4.name + '批'
        })
      }
    }
    let nursery = [];
    for (var a = 0; a < loc.loc3Names.length; a++) {
      var locName3 = loc.loc3Names[a];
      for (var b = 0; b < locName3.batchNames.length; b++) {
        var batchName3 = locName3.batchNames[b];
        nursery.push({
          grp: this.formatNum(b),
          index: a < 10 ? '0' + (a + 1) : a + 1,
          locationBar: null,
          locationName: locName3.name + batchName3.name + '批'
        })
      }
    }
    return {
      loc,
      farm,
      province,
      city,
      town,
      farrow,
      finishing,
      mate,
      gilt,
      nursery
    }
  };
  saveData = async () => {
    const storageStaffs = auth.readCookie('staff');
    let staffs = storageStaffs.map(o => {
      return {
        username: o.name,
        phoneNum: o.tel,
        id: o.id,
        type: o.role.filter(o => o.checked === true),
        contact: o.contact,
        newStaff: o.newStaff
      }
    });
    let userInfo = auth.readCookie('userInfo') || {};
    if (Object.keys(userInfo).length === 0) {
      auth.getUserInfo().then(res => {
        const {data, code, msg} = res;
        if (code === 200) {
          userInfo = data
        } else {
          // 没有获取到用户信息，无法继续下一步
          Toast.info(msg, 2, () => {
            native.callNativeModal('backHome')
          })
        }
      })
    }
    if (Object.keys(userInfo).length === 0) {
      return
    }
    const hasUser = staffs.filter(o => o.phoneNum === userInfo.phoneNum).length > 0;
    if(!hasUser) {
      staffs.push(userInfo)
    }
    const {
      finishing,
      farm,
      province,
      city,
      town,
      farrow,
      mate,
      gilt,
      nursery
    } = this.getSaveData();
    Toast.loading('请稍等', 8);
    let step1 = await send_init({
      url: `${ROOT_PATH}/api/forward/ifarm/simpleStep/saveStep1`,
      method: 'post',
      data: {
        cityCode: city.code,
        cityName: city.name,
        farmCapacity: farm.farmScale,
        farmLocaion: `${province.name},${city.name},${town.name}`,
        farmLocaionCode: `${town.code}`,
        farmManager: farm.farmMan,
        farmManagerContact: farm.tel,
        farmName: farm.farmName,
        farmType: farm.farmType,
        latitude: window.lat,
        longitude: window.lng,
        method: 'ADD',
        provinceCode: province.code,
        provinceName: province.name,
        farmHouseReq: {
          farrow,
          finishing,
          gilt,
          mate,
          nursery
        }
      }
    });
    if (step1.data.statusCode !== '200') {
      Toast.info(step1.data.msg);
      return
    }
    console.log(1, step1.data.message);
    let step2 = await send_init({
      url: '/api/ifarm/v180/staff/batch_staff',
      method: 'post',
      data: {
        method: 'add',
        staffs: staffs
      }
    });
    if (step2.data.statusCode !== 200) {
      Toast.info(step2.data.message);
      return
    }
    auth.setCookie('createdStaffs', step2.data.data);
    let step3 = await send_init({
      url: `${ROOT_PATH}/api/forward/ifarm/simpleStep/saveStep2`,
      method: 'post',
      data: {
        cityCode: city.code,
        cityName: city.name,
        farmCapacity: farm.farmScale,
        farmLocaion: `${province.name},${city.name},${town.name}`,
        farmLocaionCode: `${town.code}`,
        farmManager: farm.farmMan,
        farmManagerContact: farm.tel,
        farmName: farm.farmName,
        farmType: farm.farmType,
        latitude: window.lat,
        longitude: window.lng,
        method: 'ADD',
        provinceCode: province.code,
        provinceName: province.name
      }
    });
    if (step3.data.statusCode !== '200') {
      Toast.info(step3.data.msg);
      return
    } else if (step3.data.error) {
      Toast.info(step3.data.msg);
      return;
    }
    Toast.info('创建完成', 2, () => {
      this.props.history.replace('/createfarm/product_add');
      auth.setCookie('path', '/createfarm/product_add')
    })
  };
  setData = (data) => {
    auth.setCookie('staff', data)
  };
  checkButtonGroup = (data) => {
    return data.map((item, index) => <Button size={'small'}
        key={item.label + index}
        type={item.checked ? 'primary' : 'ghost'}
        inline
        style={{width: 100,marginBottom: 10}}
        onClick={() => {
                                               ROLEDATA[index].checked = !item.checked;
                                               let roles = ROLEDATA.filter(o => o.checked);
                                               this.setState({
                                                 role: roles
                                               })
                                             }}
                                     >{item.label || item || '文本'}</Button>)
  };
  selectStaff = o => {
    //当时我本人，就允许选中用户
    let isMe = auth.readCookie('farm') && auth.readCookie('farm').farmName.indexOf('flame0606') >=0;
    if (isMe) {
      this.setState({
        name:o.name,
        tel: o.tel,
        role:o.role
      })
    }
  };

  render() {
    const {name, tel, hasError} = this.state;
    return (
      <React.Fragment>
        <List
            renderHeader={() => ''}
            renderFooter={() => ''}
        >
          <InputItem className={'required text-right'}
              placeholder={'请输入'}
              maxLength={5}
              type={'text'}
              value={name}
              onChange={(name) => {
                       this.setState({name})
                     }}
          >
            猪场负责人
          </InputItem>
          <InputNumber
              className={'required text-right'}
              placeholder="请输入"
              error={hasError}
              pattern={'[0-9]*'}
              onErrorClick={() => {
              Toast.info(this.state.errMsg)
            }}
              onChange={value => {
              value = value.substr(0, 11);
              value = value.replace(/ /g, '');
              if (!(/^1[3456789]\d{9}$/.test(value))) {
                this.setState({
                  hasError: true,
                  errMsg: '请输入正确的手机号'
                });
              } else {
                let isUnit = auth.readCookie('staff').filter(o => value === o.tel).length === 0;
                this.setState(state => {
                  state.hasError = !isUnit;
                  state.errMsg = isUnit ? '' : '号码重复';
                  return state;
                });
              }
              this.setState({
                tel: value
              });
            }}
              value={tel}
          >手机号码</InputNumber>
          <div className={'role required'}>
          <span className="am-input-label role-text">
            角色
          </span>
            <div className={'role-extra'}>
              {this.state.role.map((item, index) => <Button size={'small'}
                  key={item.label + index}
                  type={item.checked ? 'primary' : 'ghost'}
                  inline
                  style={{width: 100,marginBottom: 10}}
                  onClick={() => {
                                                  this.setState(state =>{
                                                    state.role[index].checked = !item.checked;
                                                    return state;
                                                  })
                                                }}
                                                    >{item.label || item || '文本'}</Button>)}
            </div>
          </div>
        </List>
        {/*{JSON.stringify(this.state.role)}*/}
        <List.Item>已经添加的员工:</List.Item>
        <Flex
            wrap={'wrap'}
        >
          {
            this.state.storeStaff.map((o, index) => (
              <div key={index}
                  onClick={() => {
                    // console.log(o);
                    this.selectStaff(o)
                   }}
                  style={{
                     backgroundColor: '#fff',
                     color: '#108ee9',
                     boxSizing: 'border-box',
                     margin: '5px 6px',
                     width: 80,
                     textAlign: 'center',
                     padding: '6px 0',
                     border: '1px solid #108ee9',
                     borderRadius: '4px'
                   }}
              >
                {o.name || o.tel}
              </div>
            ))
          }
        </Flex>


        <WingBlank size="lg">
          <WhiteSpace size={'lg'}/>
          <Button
              type={'primary'}
              onClick={() => {
              this.doAdd()
            }}
          >保存并继续录入</Button>
          <WhiteSpace size={'lg'}/>
          <Button
              type={'primary'}
              onClick={() => {
              this.doSave()
            }}
          >创建完成</Button>
          <WhiteSpace size={'lg'}/>
        </WingBlank>


      </React.Fragment>
    )
  }
}
